import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=4f4d6106&scoped=true"
import script from "./TreeSelect.vue?vue&type=script&lang=js"
export * from "./TreeSelect.vue?vue&type=script&lang=js"
import style0 from "./TreeSelect.vue?vue&type=style&index=0&id=4f4d6106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d6106",
  null
  
)

export default component.exports